export const aboutData = {
  brandName: '51网址导航',
  slogan: '汇集全网精华，导航精彩世界',
  founded: '2018',
  introduction: '51网址导航成立于2018年，是国内领先的网址导航服务平台。我们致力于为网民提供最全面、最便捷的网址导航体验，收录涵盖影视视频、购物消费、新闻资讯、社交社区、搜索引擎、实用工具、学习教育、生活服务、音乐音频等九大分类的数万个优质网站。',
  mission: '让每一位用户都能在互联网的海洋中快速找到自己需要的内容，是我们的初心和使命。',
  story: [
    { year: '2018', title: '创始起航', description: '三位互联网行业老兵联合创立51网址导航，初始收录5000个网站，致力于打造中文互联网最全面的导航入口。' },
    { year: '2019', title: '快速增长', description: '网站收录数量突破2万，月活跃用户超过100万，成为国内增速最快的网址导航平台之一。' },
    { year: '2020', title: '内容升级', description: '新增"吃瓜爆料"内容板块，为用户提供娱乐圈、网红圈最新资讯与独家爆料，日活跃用户突破30万。' },
    { year: '2021', title: '品牌升级', description: '完成品牌视觉全面升级，推出移动端适配版本，全年服务用户超过1.2亿人次。' },
    { year: '2022', title: '数据驱动', description: '引入智能推荐算法，实现千人千面的个性化网址推荐，用户平均停留时长提升45%。' },
    { year: '2023', title: '生态拓展', description: '网站收录突破10万+，每日热点文章阅读量超过500万，成为中文导航领域的标杆品牌。' },
    { year: '2024', title: 'AI赋能', description: '全面接入AI技术，推出智能搜索、个性化推荐引擎，用户体验再上新台阶。' },
    { year: '2025', title: '百万网址', description: '收录网址突破百万大关，月活跃用户超5000万，稳居中文网址导航第一阵营。' },
  ],
  stats: [
    { value: '100万+', label: '收录网址' },
    { value: '5000万+', label: '月活跃用户' },
    { value: '9大', label: '核心分类' },
  ],
  testimonials: [
    { name: '张先生', role: '互联网从业者', content: '51网址导航是我的浏览器首页，找什么网站都很方便，分类清晰，更新及时，强烈推荐！' },
    { name: '李女士', role: '大学生', content: '从大一开始用51导航，现在毕业了还在用。吃瓜板块是我的快乐源泉，每天必刷！' },
    { name: '王先生', role: '自媒体人', content: '作为内容创作者，51网址导航帮我快速找到各种素材和工具网站，效率提升了不少。' },
    { name: '赵女士', role: '自由职业者', content: '页面简洁干净，没有弹窗广告，体验很好。收藏夹功能也特别实用，一个账号走天下。' },
  ],
  contact: {
    email: 'hello@chiguadao.cn',
    wechat: 'wx_51nav',
    weibo: '@51网址导航官方',
    address: '北京市朝阳区建国路88号SOHO现代城A座1206室',
    phone: '400-888-5151',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};

export const faqData = [
  { question: '51网址导航是免费的吗？', answer: '是的，51网址导航完全免费使用。我们致力于为所有用户提供最优质的网址导航服务，不收取任何费用。未来如果有增值服务，也会保持基础功能永久免费。' },
  { question: '如何将某个网站添加到导航中？', answer: '您可以通过页面底部的"提交网址"链接向我们推荐优质网站。我们的编辑团队会在24小时内进行审核，审核通过后即可上线。目前暂不支持用户自主添加。' },
  { question: '收录的网址多久更新一次？', answer: '我们每天都会对收录的网址进行可用性检测，死链会在12小时内被清理或替换。同时，编辑团队每周新增约500个经过人工审核的优质网站。' },
  { question: '吃瓜爆料的内容来源可靠吗？', answer: '我们的吃瓜爆料内容均来自多渠道交叉验证。虽然力求真实性，但由于娱乐圈信息瞬息万变，建议用户理性看待，以官方发布为准。对于已证实为虚假的内容，我们会在第一时间更正或删除。' },
  { question: '如何联系我们进行商务合作？', answer: '欢迎通过邮箱 hello@chiguadao.cn 与我们联系，商务合作专员会在1-2个工作日内回复。您也可以添加官方微信 wx_51nav 进行沟通。' },
  { question: '51网址导航有手机APP吗？', answer: '目前我们主要通过网页端提供服务，移动端网页已做了全面的响应式适配。原生APP正在开发中，预计近期将与大家见面，敬请期待！' },
];